import createAction from 'Store/utils/createAction';
import { TRIP_INFORMATION_SET_FLEXIBILITY } from './flexibility.constants';
export function setFlexibility(value: number) {
  return createAction(TRIP_INFORMATION_SET_FLEXIBILITY, {
    value,
  });
}
